// File: src/components/Header.js

import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext           from '../context/AuthContext';
import '../assets/css/Header.css';
import logo                  from '../assets/image/bio.png';

const Header = () => {
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="header-left">
        <Link to={user ? "/dashboard" : "/"}>
          <img src={logo} alt="Bio Logo" className="header-logo" />
        </Link>
      </div>

  
      {user && (
        <div className="header-right">
          <button className="header-logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
